import Swiper, { Navigation , Autoplay} from 'swiper';
Swiper.use([Navigation, Autoplay])
import breakpoints from "../../../breakpoints";

export const baseSlider = (scope) => {
	let sliders = scope?.querySelectorAll('.js-base-slider');

	sliders.forEach(slider => {
		let options = {}
		if (slider.dataset.options) {
			try { options = JSON.parse(slider.dataset.options) } catch (e) { console.log(e)}
		}

		new Swiper(slider.querySelector('.swiper:not(.swiper-container-initialized)'), {
			freeMode: true,
			autoplay: !!slider.dataset.autoplay,
			delay: slider.dataset.autoplay ? (+slider.dataset.autoplay || 1000) : false,
			watchOverflow: true,
			slidesPerView: 'auto',
			spaceBetween: 11,
			resizeObserver: true,
			loop: false,
			navigation: {
				prevEl: slider.querySelector('.swiper-button-prev'),
				nextEl: slider.querySelector('.swiper-button-next')
			},
			breakpoints: {
				[breakpoints['tablet']]: {
					freeMode: false,
					slidesPerView: slider.dataset.xlPerView || 3,
					spaceBetween: 27
				}
			},
			...options
		})
	})
}
